import { atom } from "recoil";

const phoneState =atom({
    key: 'phone',
    default: ''
})

export default phoneState